// extracted by mini-css-extract-plugin
export var box = "WhyUs-module--box--v9S7Y";
export var boxContainer = "WhyUs-module--boxContainer--636PE";
export var button = "WhyUs-module--button--egrVB";
export var container = "WhyUs-module--container--MNYsf";
export var post = "WhyUs-module--post--HrdXt";
export var subtitle = "WhyUs-module--subtitle--bkb55";